import { useState, type FormEvent } from 'react'
import Button from '../../../shared/components/Button'
import { Box } from '../../../shared/components/Box'
import { Grid } from '../../../shared/components/Grid'
import { Stack } from '../../../shared/components/Stack'
import { login } from '../api'
import { TextField } from '../../../shared/components/form'
import '../pages/AuthPage.scss'

type LoginViewProps = {
  onLogin: (user: Awaited<ReturnType<typeof login>>) => void
  variant?: 'desktop' | 'tablet' | 'mobile'
}

export function LoginDesktopView({ onLogin, variant = 'desktop' }: LoginViewProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      onLogin(await login(username, password))
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Invalid credentials')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Box as="main" className={`auth-page auth-page--${variant}`}>
      <Grid className="auth-shell">
        <section className="auth-card" aria-labelledby="login-title">
          <div className="auth-title">
            <h1 id="login-title">Authentication</h1>
          </div>
          <Stack as="form" aria-busy={submitting} onSubmit={submit}>
            <TextField
              autoComplete="username"
              autoFocus
              id="login-username"
              label="Username"
              name="username"
              onChange={(event) => setUsername(event.target.value)}
              required
              value={username}
            />
            <TextField
              autoComplete="current-password"
              id="login-password"
              label="Password"
              name="password"
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
              value={password}
            />
            {error && (
              <p className="auth-error" id="login-error" role="alert">
                {error}
              </p>
            )}
            <Button disabled={submitting} fullWidth type="submit">
              {submitting ? 'Authenticating…' : 'Authentication'}
            </Button>
          </Stack>
        </section>
      </Grid>
      <footer className="auth-footer">
        <span>v0.0.0</span>
      </footer>
    </Box>
  )
}
